var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import * as Const from "@utils/Const";
import { PromiseHttp } from "@utils/api/HttpUtil";
export default function BoardCreate(props) {
    var _a, _b;
    const { item, setItem, } = props;
    let token = localStorage.getItem(Const.TOKEN);
    let lang = localStorage.getItem(Const.LANG_TYPEA);
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [isBlind, setIsBlind] = useState(true);
    const [file, setFile] = useState([]);
    useEffect(() => {
        setTitle("");
        setContent("");
        setIsBlind(true);
        setFile([]);
    }, [item.tab]);
    // 버튼 클릭 시 input 만들기 (단일 파일만)
    const handleUpload = (e) => {
        const input = document.createElement("input");
        input.type = "file";
        input.multiple = false; // 하나만 업로드
        // 필요시 허용 확장자 지정: input.accept = "*/*";
        input.onchange = (ev) => {
            var _a;
            const target = ev.currentTarget;
            const f = (_a = target.files) === null || _a === void 0 ? void 0 : _a[0];
            if (!f)
                return;
            handleSelectFile(f);
        };
        input.click();
    };
    // 첨부파일 처리 (단일 파일)
    const handleSelectFile = (f) => {
        // 이미 1개가 있으면 추가 업로드 불가 (교체를 원하면 setFile([newItem])만 호출하고 return 제거)
        if (file.length >= 1) {
            alert("하나만 업로드 가능합니다.");
            return;
        }
        const formData = new FormData();
        formData.append("files", f);
        const newItem = {
            name: f.name,
            url: URL.createObjectURL(f),
            file: f,
            formData: formData // 서버 전송용 FormData
        };
        // 단일 파일만 허용
        setFile([newItem]);
    };
    const handleView = () => {
        setItem((prev) => (Object.assign(Object.assign({}, prev), { type: "" })));
    };
    const boardAdd = (e) => __awaiter(this, void 0, void 0, function* () {
        var isOk = confirm(`해당 ${item.depth2.menuName}을 등록하시겠습니까?`);
        if (!isOk)
            return;
        let data = null;
        data = yield PromiseHttp({
            httpMethod: Const.API_POST,
            appPath: `/admin/board/${item.boardId}/post`,
            appQuery: {
                title: title,
                content: content,
                isBlind: isBlind,
                writer: lang == Const.LANG_KOR ? "관리자" : "Admin",
                lang: lang
            },
            userToken: token,
        });
        if (data) {
            if (data.codeNum == Const.API_200) {
                if (file.length > 0 && item.depth2.url == Const.URL_NOTICE) {
                    fileAdd(data.body.postId);
                }
                else {
                    alert("게시글이 등록 되었습니다.");
                    location.reload();
                }
            }
            else {
                alert(data.body.message);
            }
        }
    });
    // 첨부파일 업로드 (단일 파일)
    const fileAdd = (postId) => __awaiter(this, void 0, void 0, function* () {
        var _c, _d;
        const formData = new FormData();
        file.map((files) => formData.append("files", files));
        let data = null;
        data = yield PromiseHttp({
            httpMethod: Const.API_POSTF,
            appPath: `/admin/file/post/${postId}`,
            appQuery: formData,
            userToken: token,
        });
        if (data) {
            if (data.codeNum == Const.API_200) {
                alert(`게시글이 등록 완료되었습니다.`);
                location.reload();
            }
            else {
                alert((_d = (_c = data.body) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : "파일 업로드 실패");
            }
        }
    });
    return (_jsx(_Fragment, { children: _jsxs("section", Object.assign({ className: "board-main" }, { children: [_jsx("div", Object.assign({ className: "board-header" }, { children: _jsxs("h4", { children: ["\uAC8C\uC2DC\uD310 \uAD6C\uBD84: ", item.depth2.menuName] }) })), ((_a = item.depth2) === null || _a === void 0 ? void 0 : _a.url) === Const.URL_NOTICE &&
                    _jsx(Notice, { title: title, setTitle: setTitle, content: content, setContent: setContent, isBlind: isBlind, setIsBlind: setIsBlind, file: file, setFile: setFile, boardAdd: boardAdd, handleView: handleView, handleUpload: handleUpload }), ((_b = item.depth2) === null || _b === void 0 ? void 0 : _b.url) === Const.URL_FAQ && _jsx(Faq, { title: title, setTitle: setTitle, content: content, setContent: setContent, isBlind: isBlind, setIsBlind: setIsBlind, boardAdd: boardAdd, handleView: handleView })] })) }));
}
;
function Notice(props) {
    var _a;
    const { title, setTitle, content, setContent, isBlind, setIsBlind, file, boardAdd, handleView, handleUpload } = props;
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "board-section" }, { children: [_jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "\uC81C\uBAA9" }), _jsx("input", { type: "text", value: title, onChange: (e) => setTitle(e.target.value) })] })), _jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "\uCCA8\uBD80\uD30C\uC77C" }), _jsx("input", { type: "text", disabled: true, value: (_a = file[0]) === null || _a === void 0 ? void 0 : _a.name }), _jsx("button", Object.assign({ className: "img-btn", onClick: (e) => handleUpload(e) }, { children: "\uD30C\uC77C \uC120\uD0DD" }))] })), _jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "\uB0B4\uC6A9" }), _jsx("textarea", { value: content, onChange: (e) => setContent(e.target.value) })] })), _jsxs("div", Object.assign({ className: "board-footer" }, { children: [_jsxs("label", Object.assign({ className: "checkbox" }, { children: [_jsx("input", { type: "checkbox", name: "active", checked: isBlind, onChange: (e) => setIsBlind(e.target.checked) }), " \uAC8C\uC2DC\uAE00 \uD65C\uC131\uD654"] })), _jsxs("div", Object.assign({ className: "btn-box" }, { children: [_jsx("button", Object.assign({ onClick: (e) => boardAdd(e) }, { children: "\uB4F1\uB85D" })), _jsx("button", Object.assign({ onClick: handleView }, { children: "\uCDE8\uC18C" }))] }))] }))] })) }));
}
;
function Faq(props) {
    const { title, setTitle, content, setContent, isBlind, setIsBlind, boardAdd, handleView, } = props;
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "board-section" }, { children: [_jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "Q" }), _jsx("input", { type: "text", value: title, onChange: (e) => setTitle(e.target.value) })] })), _jsxs("div", Object.assign({ className: "row" }, { children: [_jsx("label", { children: "A" }), _jsx("textarea", { value: content, onChange: (e) => setContent(e.target.value) })] })), _jsxs("div", Object.assign({ className: "board-footer" }, { children: [_jsxs("label", Object.assign({ className: "checkbox" }, { children: [_jsx("input", { type: "checkbox", name: "active", checked: isBlind, onChange: (e) => setIsBlind(e.target.checked) }), " \uAC8C\uC2DC\uAE00 \uD65C\uC131\uD654"] })), _jsxs("div", Object.assign({ className: "btn-box" }, { children: [_jsx("button", Object.assign({ onClick: (e) => boardAdd(e) }, { children: "\uB4F1\uB85D" })), _jsx("button", Object.assign({ onClick: handleView }, { children: "\uCDE8\uC18C" }))] }))] }))] })) }));
}
